import { ResponseDto } from '../dtos/response.dto';

export class ResponseModel {
    private _response: ResponseDto;

    public constructor(response: ResponseDto) {
        this._response = response;
    }

    public get successful(): boolean {
        return this._response.responseCode === 0;
    }

    public get message(): string {
        return this._response.responseMessage;
    }

    public get responseCode(): number {
        return this._response.responseCode;
    }
}
